import injectorDirectiveFactory from 'gw-portals-util-angular/injectorDirectiveFactory';

var loadContext = function loadContext(context) {
    return context.keys().map(function (key) {
        return context(key).default;
    });
};
export default [injectorDirectiveFactory('gwMobileScheduleListItem', { scheduledItem: '<', directive: '<' }, loadContext(require.context('./subdirectives/list', true, /\.js$/)), ['$scope', function ($scope) {
    return $scope.directive;
}]), injectorDirectiveFactory('gwMobileScheduleEditItem', {
    schedule: '<',
    scheduledItem: '<',
    directive: '<',
    shouldShowErrors: '<',
    onBeforeCommit: '<'
}, loadContext(require.context('./subdirectives/edit', true, /\.js$/)), ['$scope', function ($scope) {
    return $scope.directive;
}])];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/SubdirectiveInjecotrs.js
// module id = 801
// module chunks = 0